import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class ProjectCustomDomainsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Check custom domain registration
     * Check if custom domain is registered.
     * @returns void
     * @throws ApiError
     */
    checkProjectCustomDomain({ domain, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/custom-domain-check', query: {
                'domain': domain,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List project custom domains
     * @returns ProjectCustomDomainList Custom domain for project.
     * @throws ApiError
     */
    listProjectCustomDomains({ orgId, projectId, after, before, sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/custom-domains', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, query: {
                'after': after,
                'before': before,
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Upsert custom domain for project
     * @returns ProjectCustomDomain Project custom domain created.
     * @throws ApiError
     */
    upsertProjectCustomDomain({ orgId, projectId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/custom-domains', path: {
                'orgId': orgId,
                'projectId': projectId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete custom domain for project
     * @returns void
     * @throws ApiError
     */
    deleteProjectCustomDomain({ orgId, projectId, customDomainId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/projects/{projectId}/custom-domains/{customDomainId}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'customDomainId': customDomainId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Create project custom domain verification
     * @returns void
     * @throws ApiError
     */
    createProjectCustomDomainVerification({ orgId, projectId, customDomainId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/projects/{projectId}/custom-domains/{customDomainId}/verifications', path: {
                'orgId': orgId,
                'projectId': projectId,
                'customDomainId': customDomainId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=ProjectCustomDomainsService.js.map